import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SectionHead from '../components/SectionHead';
import Reveal from '../components/Reveal';
import { BTN_PRIMARY } from '../components/styles';
import { INDUSTRIES } from '../content/industries';
import usePageMeta from '../hooks/usePageMeta';

export default function Industries() {
  usePageMeta(
    'Stove Safety by Industry | RangeSafe Commercial Solutions',
    'Stove safety knob guidance for property owners and managers, government facilities, hospitality, education, assisted living and restaurant operators.'
  );
  return (
    <main className="pt-16">
      <header className="mx-auto max-w-shell px-5 pb-16 pt-20 sm:px-8 lg:pt-28">
        <SectionHead
          as="h1"
          eyebrow="Buyer Groups"
          lines={['Solutions for', 'Your Industry']}
          lead="Explore RangeSafe solutions for your industry, with guidance on product selection, pilot programs, purchasing and installation."
        />
      </header>

      <div className="mx-auto max-w-shell space-y-14 px-5 pb-24 sm:px-8 lg:space-y-20" data-testid="industries-list">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind.slug} delay={0.05}>
            <Link to={`/industries/${ind.slug}`} className="group grid items-center gap-8 md:grid-cols-12" data-testid={`industry-card-${ind.slug}`}>
              <div className={`md:col-span-7 ${i % 2 === 1 ? 'md:order-2' : ''}`}>
                <div className="overflow-hidden border border-line">
                  <img src={ind.image} alt={ind.alt} className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" width="1600" height="900" loading="lazy" />
                </div>
              </div>
              <div className="md:col-span-5">
                <p className="font-mono text-[11px] tracking-[0.3em] text-accentText">0{i + 1}</p>
                <h2 className="mt-3 font-display text-3xl font-bold uppercase leading-none tracking-tight text-white sm:text-4xl">{ind.name}</h2>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-dim sm:text-base">{ind.lead}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-white border-b border-line pb-1 transition-colors group-hover:border-accent">
                  Explore <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>

      <section className="border-t border-line bg-panel/40">
        <div className="mx-auto flex max-w-shell flex-col items-start gap-8 px-5 py-20 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
          <Reveal>
            <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
              Not sure where you fit?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/contact" className={BTN_PRIMARY} data-testid="industries-quote-cta">Contact Commercial Solutions Team</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
